import { StyledIconIBMCloud } from './IconIBMCloud.styled';

const IconIBMCloud = () => {
  return <StyledIconIBMCloud />;
};

export default IconIBMCloud;
